export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14112.6c855ff1.jpg";